module.exports = __webpack_public_path__ + "img/kangxin3.27298b17.jpg";